import { reactive } from 'vue'
import { Configuration, PublicClientApplication, AccountInfo } from '@azure/msal-browser'
import { AuthenticationConfig } from './authenticationOidc'

let myMSALObj: PublicClientApplication | null = null
const state = reactive({
  isAuthenticated: false,
  user: null as AccountInfo | null
})

export const useAuthentication = () => {
  return {
    state,
    login: async () => {
      try {
        if (!myMSALObj) {
          throw new Error('msal Not initialized. Call initializeMsal() before using MSAL API.')
        }
        await myMSALObj.loginRedirect()
      } catch (error) {
        console.error('Login error:', error)
      }
    },
    logout: async () => {
      if (!myMSALObj) {
        throw new Error('msal Not initialized. Call initializeMsal() before using MSAL API.')
      }
      await myMSALObj.logoutRedirect()
      state.isAuthenticated = false
      state.user = null
    },
    handleRedirect: async () => {
      try {
        if (!myMSALObj) {
          throw new Error('msal Not initialized. Call initializeMsal() before using MSAL API.')
        }
        await myMSALObj.handleRedirectPromise()
        state.isAuthenticated = myMSALObj.getAllAccounts().length > 0
        state.user = myMSALObj.getAllAccounts()[0]
      } catch (error) {
        console.error('Redirect error:', error)
      }
    },
    // use it to add the authentication token on HTTP calls to the backend
    getAccessToken: async (): Promise<string | null> => {
      if (!myMSALObj) {
        throw new Error('MSAL not initialized. Call initializeMsal() before using MSAL API.')
      }
      try {
        const accounts = myMSALObj.getAllAccounts()
        if (accounts.length === 0) {
          throw new Error('No accounts found. Please login first.')
        }
        const silentRequest = {
          scopes: ['user.read', 'openid', 'profile'],
          account: accounts[0]
        }
        const silentResponse = await myMSALObj.acquireTokenSilent(silentRequest)
        return silentResponse.accessToken
      } catch (error) {
        console.error('Silent token acquisition error:', error)
        return null
      }
    },
    getUserProfile: () => {
      // The information to return here will be in state.user;
      return {}
    }
  }
}

export const init = async (config: AuthenticationConfig) => {
  const msalConfig: Configuration = {
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      redirectUri: config.redirectLogin,
      postLogoutRedirectUri: config.redirectLogout,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'sessionStorage'
    }
  }
  myMSALObj = new PublicClientApplication(msalConfig)
  await myMSALObj.initialize()
}
